import React, { useContext, useState } from 'react';
import { DownloadContext } from './DownloadContext';

const DownloadProgressModal = () => {
  const { downloads, cancelDownload } = useContext(DownloadContext);
  const [showAll, setShowAll] = useState(false);

  if (downloads.length === 0) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 uploadfile_loader_wrapper">
      <div className="">
        {downloads.length > 1 && (
          <div className="multiple_upload_control_row">
            <h5>Downloading {downloads.length} files</h5>
            <button onClick={() => setShowAll((prev) => !prev)} className="btn_upload_showall">
              <i className="mdi mdi-arrow-expand"></i>
            </button>
          </div>
        )}

        {downloads.map((download, index) => (
          <div key={download.id} className="mb-4">
            {(showAll || index === 0) && (
              <>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mr-2"></div>
                    <div className="uploading_files_with_complete_row">
                      <h6>{download.fileName}...</h6>
                      <p>
                        <span>{Math.round(download.progress)}</span>% Complete
                      </p>
                      <button
                    className="cancel-download-btn"
                    onClick={() => cancelDownload(download.id)}
                  >
                    Cancel
                  </button>
                    </div>
                  </div>

                  {/* Cancel button */}
                  
                </div>

                <div className="progress-bar-container">
                  <div
                    className="progress-bar"
                    style={{ width: `${download.progress}%` }}
                  />
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DownloadProgressModal;
